export default "__VITE_ASSET__DUwqcQTT__"